import type { ReactElement } from "react";
import { Icon } from "@chakra-ui/react";
import type { IconProps } from "@chakra-ui/react";

const MediumLogo = ({ color = "#fff", ...props }: IconProps): ReactElement => (
  <Icon viewBox="0 0 128 128" color={color} {...props}>
    <title>Medium Logo</title>
    <circle fill="currentColor" cx={64} cy={64} r={64} />
    <path
      fill="#fff"
      d="M69.457 64.408c0 14.585-11.742 26.41-26.229 26.41C28.742 90.817 17 78.996 17 64.407 17 49.82 28.743 38 43.228 38c14.486 0 26.23 11.823 26.23 26.408zm28.774 0c0 13.73-5.872 24.86-13.114 24.86-7.243 0-13.115-11.133-13.115-24.86 0-13.726 5.872-24.86 13.115-24.86 7.242 0 13.114 11.134 13.114 24.86zm11.769 0c0 12.302-2.065 22.273-4.613 22.273-2.547 0-4.612-9.975-4.612-22.273s2.065-22.273 4.613-22.273c2.548 0 4.612 9.973 4.612 22.273z"
    />
  </Icon>
);

export default MediumLogo;
